import { gql } from "@apollo/client";

export const LOAD_ORGANIZATION_MEMBERS = gql`
  query LoadOrganizationMembers(
    $mrn: String!
    $first: Int
    $after: String
    $orderBy: MembershipOrder
    $query: String
  ) {
    organization(mrn: $mrn) {
      id
      mrn
      company
      members(
        first: $first
        after: $after
        orderBy: $orderBy
        query: $query
        identityTypeFilter: [USER]
      ) {
        edges {
          cursor
          node {
            identity {
              mrn
              name
              ... on User {
                email
              }
            }
            roles {
              mrn
              title
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
      }
    }
  }
`;
